import type { ProfileVisibilityOptions } from './types';

// Only used to mock local mutation behaviour
export const getOptionFromProfileVisibilityId = (
  profileVisibilityOptions: ProfileVisibilityOptions,
  id: string,
) => profileVisibilityOptions.find((option) => option.id === id);
